import { Box } from "@mui/material";
import Input from "../../../../../../components/ui/Input";
import RichTextEditor from "../../../../../../components/ui/RichTextEditor";
import Select from "../../../../../../components/ui/Select";
import Text from "../../../../../../components/ui/Text";
import { PLAYERS_TEAM_SIZE } from "../../../../../../constants/game";

const PlayerDetails = ({ gameData, onGameInputChange }) => {
  return (
    <Box>
      <Box sx={{ mb: "16px" }}>
        <Text variant="subtitle3">Add player details</Text>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Select
          label="Maximum Players"
          placeholder="Select max players"
          value={gameData.players}
          onChange={onGameInputChange("players")}
          options={[
            { value: PLAYERS_TEAM_SIZE.ONE_V_ONE, label: "2 (1v1)" },
            { value: PLAYERS_TEAM_SIZE.TWO_V_TWO, label: "4 (2v2)" },
            { value: PLAYERS_TEAM_SIZE.THREE_V_THREE, label: "6 (3v3)" },
            { value: PLAYERS_TEAM_SIZE.FOUR_V_FOUR, label: "8 (4v4)" },
            { value: PLAYERS_TEAM_SIZE.FIVE_V_FIVE, label: "10 (5v5)" },
            { value: PLAYERS_TEAM_SIZE.SIX_V_SIX, label: "12 (6v6)" },
            { value: PLAYERS_TEAM_SIZE.SEVEN_V_SEVEN, label: "14 (7v7)" },
            { value: PLAYERS_TEAM_SIZE.EIGHT_V_EIGHT, label: "16 (8v8)" },
            { value: PLAYERS_TEAM_SIZE.NINE_V_NINE, label: "18 (9v9)" },
            { value: PLAYERS_TEAM_SIZE.TEN_V_TEN, label: "20 (10v10)" },
            { value: PLAYERS_TEAM_SIZE.ELEVEN_V_ELEVEN, label: "22 (11v11)" },
            { value: PLAYERS_TEAM_SIZE.TWELVE_V_TWELVE, label: "24 (12v12)" },
            {
              value: PLAYERS_TEAM_SIZE.THIRTEEN_V_THIRTEEN,
              label: "26 (13v13)",
            },
            {
              value: PLAYERS_TEAM_SIZE.FOURTEEN_V_FOURTEEN,
              label: "28 (14v14)",
            },
            { value: PLAYERS_TEAM_SIZE.FIFTEEN_V_FIFTEEN, label: "30 (15v15)" },
          ]}
        />

        <Input
          label="WhatsApp Group Link (Optional)"
          placeholder="https://chat.whatsapp.com/yourinvitecode"
          value={gameData.whatsapp_link}
          onChange={onGameInputChange("whatsapp_link")}
          sx={{ mt: 2 }}
        />

        <RichTextEditor
          label="Description (optional)"
          value={gameData.description}
          onChange={(html) => {
            onGameInputChange("description")({ target: { value: html } });
          }}
        />
      </Box>
    </Box>
  );
};

export default PlayerDetails;
